import theme from 'ComponentLibrary/src/styles/theme'

export type HeadlineVariants = 'headline1' | 'headline2' | 'headline3' | 'headline4' | 'headline5'

const themeSpacingNumber = (value: number) => {
    return Number(theme.spacing(value).slice(0, -2))
}

export const contentSpacing = themeSpacingNumber(6)
export const denseContentSpacing = themeSpacingNumber(3)

export const headlineToHeadlineSpacing = (variant: HeadlineVariants, topOfThePage: boolean) => {
    let headlineToHeadlineSpacing: number
    switch (variant) {
        case 'headline1':
        case 'headline2':
            headlineToHeadlineSpacing = themeSpacingNumber(4)
            break
        case 'headline3':
        case 'headline4':
        case 'headline5':
        default:
            headlineToHeadlineSpacing = themeSpacingNumber(3)
            break
    }

    //TODO: REMOVE THIS LINE when firefox supporst :has()
    if (!topOfThePage) {
        headlineToHeadlineSpacing -= headlineToContentSpacing(variant)
    }

    return headlineToHeadlineSpacing
}

export const headlineToContentSpacing = (variant: HeadlineVariants) => {
    let headlineToContentSpacing: number
    switch (variant) {
        case 'headline1':
            headlineToContentSpacing = themeSpacingNumber(4)
            break
        case 'headline2':
        case 'headline3':
        case 'headline4':
            headlineToContentSpacing = themeSpacingNumber(3)
            break
        case 'headline5':
        default:
            headlineToContentSpacing = themeSpacingNumber(2)
            break
    }

    return headlineToContentSpacing
}

export const contentToHeadlineSpacing = (variant: HeadlineVariants) => {
    let contentToHeadlineSpacing: number
    switch (variant) {
        case 'headline1':
        case 'headline2':
            contentToHeadlineSpacing = themeSpacingNumber(8)
            break
        case 'headline3':
        case 'headline4':
        case 'headline5':
        default:
            contentToHeadlineSpacing = themeSpacingNumber(6)
            break
    }
    return contentToHeadlineSpacing
}
